import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import UserEditRoutes from './routes'

const UserEdit = () => {
  const { userId } = useNumericParams()

  useReduxAction(
    'users',
    'loadUser',
    {
      entityId: userId,
      include_image_sizes: true,
      include_user_association: true,
      include_user_customizable_permissions: true,
      include_user_ebu_assigned_users: true,
      include_brand_custom_profile_user_profile_ids: true,
      include_user_image: true,
      include_user_media_links: true,
      include_user_type: true,
    },
    [userId],
    {
      dispatchAction: (action, requestOptions) => action(userId, requestOptions),
      // @ts-expect-error TS2322
      shouldPerformFn: ({ loading }) => userId && !loading,
    },
  )

  return (
    <UserEditRoutes />
  )
}

export default UserEdit
